<template>
  <div class="company-job-list">
    <div class="aside-card-container">
      <FilterList
        v-rect-loading="filterListLoading"
        ref="filterListRef"
        class="card-container"
        :filter-list="filterList"
        :keyword="keyword"
        :selected="selectedFilterValue"
        :selectedFilterId="selectedFilterId"
        @change="onFilterChange"
      />
      <div v-if="company.preference_survey?.show_entrance" class="card-container job-alert">
        <div class="card-title">{{ $t('company.label.jobAlert') }}</div>
        <el-button class="job-alert-btn" @click="handelSurveyClick">{{ company.preference_survey.has_answered ? $t('company.btn.EditJobAlert') : $t('company.btn.createJobAlert') }}</el-button>
      </div>
      <div v-if="qrCode.loading || qrCode.src" class="card-container follow-us">
        <div class="card-title">{{ $t('company.label.followUs') }}</div>
        <div class="qr-code-image-wrapper">
          <img v-if="qrCode.src" class="qr-code-image" :src="qrCode.src" />
          <div v-else v-rect-loading="true" class="qr-code-image is-empty"></div>
        </div>
      </div>
    </div>
    <div v-rect-loading="loading" class="job-list-container">
      <div class="list-head">
        <div class="title-container">
          <div class="title">{{ $t('company.label.availableJobs') }}</div>
          <div class="job-count">{{ $t('company.label.totalJobCount', {count: pagination.total}) }}</div>
          <div class="share-btn" @click="handleShareJobClick">
            <i class="share-icon iconfont icona-bianzu62"></i>
          </div>
        </div>
        <div class="condition-container">
          <div class="condition-list">
            <div
              v-for="(condition, index) in conditionList"
              v-auto-tooltip.always="{content: condition.contentI18nKey ? $t(condition.contentI18nKey) : condition.content}"
              class="condition"
              :key="index"
            >
              <span class="condition-label">{{ condition.label || $t(condition.labelI18nKey) }}</span>
              <span class="remove-btn" @click="onConditionRemoveClick(condition, index)">
                <i class="remove-icon el-icon-close"></i>
              </span>
            </div>
            <div v-show="conditionList.length > 0" class="clear-btn" @click="onClearBtnClick">
              <i class="clear-icon iconfont iconRefresh"></i>
            </div>
          </div>
        </div>
      </div>
      <div v-if="jobList && jobList.length" class="job-list">
        <JobInfo
          v-for="(job) in jobList"
          :key="job.id"
          :jobId="job.id"
          :jobName="job.i18nName"
          :isHotJob="job.isHot"
          :openDate="job.createdTime"
          :roleType="$t(`${i18nPrefix}.roleType.${job.roleType}`)"
          :locationList="job.job_locations"
          :company="company"
          :referralSettings="job.referral_settings"
          :hasCustomReferralWord="job.company.has_referral_word_customized"
          :isHiddenRewards="isHiddenRewards()"
          :isUsePointReplacePayroll="isUsePointReplacePayroll(job)"
          :isFosunCompany="job.company.is_fosun_company"
          :isOverseasCompany="job.is_overseas"
          :isCompanyEmployee="isEmployeeOfCompany(job)"
          :isADPCompany="isADPCompany()"
          :isCoachCompany="isCoachCompany()"
          :customizationRewardsRules="job.company.customization_rewards_rules"
          @openLocationMap="handleOpenLocationMap($event, job)"
        />
        <el-pagination
          class="pagination"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.page"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <div v-else class="job-list">
        <p>{{ $t('company.message.noJob') }}</p>
        <p>{{ $t('company.message.tryOtherKeyword') }}</p>
      </div>
    </div>
    <DialogWrapper
      hideFooter
      titleI18nKey="admin.job.editor.btn.shareBtn"
      class="share-dialog"
      :class="hiddenShareDialog && 'hidden-dialog'"
      width="756px"
      :show.sync="showShareDialog"
    >
      <template v-if="!hiddenReferShare">
        <div class="share-title">{{ $t(`${i18nPrefix}.label.shareTitle`) }}</div>
        <ShareJobContent
          class="share-job-content"
          backOpenParamKey="open_share"
          hiddenReferralRoleCheck
          :shareLink="shareLink"
          :isInChina="true"
          :rootCompanyId="company.root_company.id"
          :companyId="company.id"
          :companyName="company.i18nName"
          :companyLogoPath="company.logo"
          :shareToWeChatQrCodeUrl="shareToWeChatQrCodeUrl"
          :shareToQrCodeUrl="shareToQrCodeUrl"
        ></ShareJobContent>
        <div v-if="showLearnMore" class="learn-more">
          <a target="_blank" @click="handleShowLearnMore"> {{ $t('jobDetail.learnMore') }} ></a>
        </div>
      </template>
      <!-- 公司海报 -->
      <JobPosterInfo
        v-if="jobPosters && jobPosters.length > 0"
        class="job-poster-info"
        :shareLink="shareLink"
        :company="company"
        :jobList="jobList"
        :initJobPosters="jobPosters"
        @showPosterDialog="showPosterDialog"
        @closedPosterDialog="closedPosterDialog"
      >
      <template #poster-before="{loadJobPoster, jobPosterList}">
        <div v-if="loadJobPoster || jobPosterList?.length > 0">
          <el-divider v-if="!hiddenReferShare" >{{ $t('common.or') }}</el-divider>
          <div class="job-poster-title">{{ $t(`${i18nPrefix}.label.jobPosterTitle`) }}</div>
        </div>
        </template>
      </JobPosterInfo>
    </DialogWrapper>
    <!-- 职位地点-地图 -->
    <LocationMap
      :show.sync="showJobLocationMap"
      :locationList="locationMapDialogInfo.locationList"
      :defaultLocation="locationMapDialogInfo.defaultLocation"
    ></LocationMap>
    <!-- 推荐角色 dialog -->
    <DialogWrapper
      class="share-content-referral-role-dialog-job-list"
      appendToBody
      :show.sync="showReferralRoleDialog"
      :titleI18nKey="`${i18nPrefix}.label.referralRoleTitle`"
      :saveBtnLabelI18nKey="`${i18nPrefix}.btn.yes`"
      :cancelBtnLabelI18nKey="`${i18nPrefix}.btn.no`"
      @save="handleSubmitIsEmployee"
      @cancel="handleSubmitNoEmployee"
      @closed="handleCloseReferralRoleDialog"
    >
      <div class="referral-role-content">{{ $t(`${i18nPrefix}.label.referralRoleTipContent`, { company: company.has_referral_share ? company.root_company.i18nName : company.i18nName }) }}</div>
    </DialogWrapper>
    <!-- 确认创建提醒 -->
    <JobAlertConfirmDialog
      isPc
      :show.sync="showJobAlertDialog"
      :companyId="company.id"
      :logo="company.logo"
      :isAgreed="personalAgreementStatus?.is_agreed"
    ></JobAlertConfirmDialog>
  </div>
</template>

<script>
import JobInfo from '@/components/company/jobList/jobInfo.vue'
import FilterList from '@/components/company/jobList/filterList.vue'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import ShareJobContent from './components/shareJobContent.vue'
import LocationMap from './components/locationMap.vue'
import JobAlertConfirmDialog from '@/components/job/jobDetail/jobAlertConfirmDialog.vue'
import JobPosterInfo from './components/jobPosterInfo.vue'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import { isEn, addI18nProperty } from '@/i18n'
import { ROOT_COMPANY_ID } from '@/constant/company'

const CUSTOM_FILTER_PREFIX = 'custom_filter_'

const ROLE_TYPE_MAP = {
  F: 'FULL_TIME',
  P: 'PART_TIME',
  I: 'INTERNSHIP'
}

export default {
  components: {
    JobInfo,
    FilterList,
    DialogWrapper,
    ShareJobContent,
    LocationMap,
    JobAlertConfirmDialog,
    JobPosterInfo
  },
  props: {
    isMSDCustom: {
      type: Boolean,
      default: false
    },
    company: {
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.job.editor',
      loading: false,
      filterListLoading: false,
      filterList: [],
      locationFilter: null,
      keyword: null,
      selectedFilterValue: {},
      conditionList: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      qrCode: {
        loading: true,
        src: null
      },
      jobList: [],
      showShareDialog: false,
      shareLink: window.location.href,
      shareToQrCodeUrl: '',
      posterListData: [],
      showJobLocationMap: false,
      locationMapDialogInfo: {
        locationList: [],
        defaultLocation: null
      },
      selectedFilterId: null,
      showReferralRoleDialog: false,
      showJobAlertDialog: false,
      hiddenShareDialog: false,
      jobPosters: null,
      isPageChange: false,
      personalAgreementStatus: null,
      surveyInfo: {}
    }
  },
  computed: {
    ...mapGetters('account', ['isCandidateAccount']),
    shareToWeChatQrCodeUrl () {
      const query = this.$route.query
      let url = `/mobile-web-more-jobs/${this.company.id}`
      if (_.size(query) > 0) {
        url = `${url}?${_.map(query, (value, key) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&')}`
      }
      const hashQuery = this.loadUrlQuery()
      const hashStr = this.getHashQuery(hashQuery)
      if (hashStr) {
        url = `${url}#${hashStr}`
      }
      return url
    },
    accountIsExits () {
      const account = this.getCurrentAccount()
      const softUser = this.getCurrentSoftUser()
      if (account?.id || softUser?.id) {
        return true
      } else {
        return false
      }
    },
    scrollToList () {
      return this.$route.query.scroll_to_list === '1'
    },
    showLearnMore () {
      return this.company?.root_company.id !== 4753
    },
    hasReferralPermission () {
      return this.company.premium?.referral
    },
    hiddenReferShare () {
      return this.company?.root_company.id === ROOT_COMPANY_ID.MERCEDES_BENZ
    },
    hasLogin () {
      const account = this.getCurrentAccount()
      return Boolean(account?.id)
    }
  },
  created () {
    this.debounceSearch = _.debounce(this.search, 1000)
    this.initData()
  },
  methods: {
    ...mapGetters('account', ['getCurrentAccount', 'getCurrentSoftUser']),
    ...mapActions('company', ['getCompanyCustomJobFilterList']),
    ...mapActions('job', ['searchCompanyJobList', 'countShareTimes', 'getJobDetailJobPoster']),
    ...mapActions('wechat', ['getCompanyWxQrCode']),
    ...mapActions('referral', ['getReferralShareQrCode']),
    ...mapActions('eventTrack', ['trackCandidateViewJobList']),
    ...mapActions('personal', ['getAgreementStatus']),
    ...mapActions('survey', ['getSurveyInfo']),
    async initData () {
      this.loadWxQrCode()
      this.trackCandidateViewJobList({ company_id: this.company.id })
      this.loadJobPoster()
      this.initPersonalAgreementStatus()
      this.initSurveyInfo()
      await this.search(true)
      const query = this.loadUrlQuery()
      this.$nextTick(() => {
        if (this.scrollToList) {
          this.scrollToJobList()
        }
        if (query.open_share === '1') {
          this.scrollToJobList()
          this.handleShowShareDialog()
          const newQuery = _.omit(query, 'open_share')
          const hashStr = this.getHashQuery(newQuery)
          if (this.isMSDCustom) {
            window.history.pushState({}, '', `${this.$route.path}#${hashStr}`)
          } else {
            window.history.pushState({}, '', `/recruiting/company/${this.company.id}/job-list#${hashStr}`)
          }
        }
      })
    },
    initFilterValue (query) {
      const conditionList = []
      this.keyword = query.keywords
      if (this.keyword) {
        conditionList.push(this.parseFilterToCondition('keyword', this.keyword))
      }
      const selectedFilterValue = {}
      _.forEach(query, (val, key) => {
        if (!val) {
          return
        }
        let defaultFilterName = null
        if (key === 'rt') {
          defaultFilterName = 'Role Type'
        } else if (key === 'jwt') {
          defaultFilterName = 'Work Time'
        } else if (key === 'js') {
          defaultFilterName = 'Salary'
        } else if (key === 'city') {
          defaultFilterName = 'Location'
        }
        if (!key.startsWith(CUSTOM_FILTER_PREFIX) && !defaultFilterName) {
          return
        }
        let filterId = null
        let filter = null
        if (defaultFilterName) {
          filter = _.find(this.filterList, { name: defaultFilterName, is_default: true })
          filterId = filter.id
        } else {
          filterId = parseInt(key.slice(CUSTOM_FILTER_PREFIX.length))
          filter = _.find(this.filterList, { id: filterId })
        }
        if (!filter) {
          return
        }
        const selectedIds = _.chain(val).split(',').filter().map(valItem => key === 'rt' ? valItem : parseInt(valItem)).value()
        selectedFilterValue[filterId] = selectedIds
        _.forEach(selectedIds, (selectId) => {
          const filterValue = _.find(filter.option_list, { id: selectId })
          if (!filterValue) {
            return
          }
          conditionList.push(this.parseFilterToCondition(filter, filterValue))
        })
      })
      this.selectedFilterValue = selectedFilterValue
      this.conditionList = conditionList
    },
    async loadWxQrCode () {
      this.qrCode.loading = true
      try {
        const resp = await this.getCompanyWxQrCode({
          company_id: this.company.id
        })
        if (resp.data) {
          this.qrCode.src = 'data:image/png;base64,' + resp.data
        }
      } finally {
        this.qrCode.loading = false
      }
    },
    async loadFilterList (jobSearchParams) {
      if (!this.company?.id) {
        return
      }
      this.filterListLoading = true
      try {
        const resp = await this.getCompanyCustomJobFilterList({
          companyId: this.company.id,
          params: {
            with_option: 1,
            with_job_count: 1,
            ...jobSearchParams
          }
        })
        if (resp) {
          this.filterList = this.restFilterList(resp)
        }
      } finally {
        this.filterListLoading = false
      }
    },
    async loadJobPoster () {
      const params = {
        company_id: this.company.id,
        language_code: isEn() === 'en' ? 'en' : 'cn'
      }
      const resp = await this.getJobDetailJobPoster(params)
      if (resp) {
        this.jobPosters = resp.job_poster_list
      }
    },
    formatFilterOptions (hasSelectedFilter, filter, selectFilterOptionIds, isLocation) {
      const sameFilterOptionIds = []
      const optionPropertyKey = isLocation ? 'i18nName' : 'label'
      const cnPropertyKey = isLocation ? 'city.cn_name' : 'cn_name'
      const enPropertyKey = isLocation ? 'city.name' : 'name'
      if (hasSelectedFilter) {
        _.forEach(filter.option_list, option => {
          if (isLocation) {
            option.id = option.city.id
          }
          addI18nProperty(option, optionPropertyKey, cnPropertyKey, enPropertyKey)
          option.job_count = _.intersection(this.allJobIds, option.job_ids).length
          if (!_.includes(selectFilterOptionIds, option.id)) {
            option.showZeroJobCount = this.selectedFilterId === filter.id
            if ((this.selectedFilterId && this.selectedFilterId === filter.id) || !this.selectedFilterId) {
              sameFilterOptionIds.push(option.id)
            }
          }
          filter.optionList.push(option)
        })
      } else {
        _.forEach(filter.option_list, option => {
          if (isLocation) {
            option.id = option.city.id
          }
          addI18nProperty(option, optionPropertyKey, cnPropertyKey, enPropertyKey)
          option.job_count = _.intersection(this.allJobIds, option.job_ids).length
          option.showZeroJobCount = this.selectedFilterId === filter.id
          filter.optionList.push(option)
        })
      }
      return sameFilterOptionIds
    },
    restFilterList (filterList) {
      const oldFilterList = _.cloneDeep(this.filterList)
      return _.map(filterList, filter => {
        const isLocation = filter.is_default && filter.name === 'Location'
        const selectFilterList = _.chain(this.conditionList).filter(condition => condition.id === filter.id).map(condition => condition.filterValue).value()
        if (this.selectedFilterId === filter.id && selectFilterList.length && this.selectedFilterId === filter.id) {
          const oldFilter = _.find(oldFilterList, { id: filter.id })
          const optionIdKey = isLocation ? 'city.id' : 'id'
          _.forEach(oldFilter.optionList, oldOption => {
            const newOption = _.find(filter.option_list, option => _.get(option, optionIdKey) === _.get(oldOption, optionIdKey))
            oldOption.job_count = _.intersection(this.allJobIds, newOption.job_ids).length
          })
          return oldFilter
        }
        const selectIds = this.selectedFilterValue[filter.id]
        const selectFilterOptionIds = _.map(selectFilterList, 'id')
        const hasSelectedFilter = _.find(this.conditionList, condition => condition.id === filter.id)
        let type = 'text'
        if (isLocation) {
          type = 'location'
          filter.optionList = []
          const sameFilterOptionIds = this.formatFilterOptions(hasSelectedFilter, filter, selectFilterOptionIds, isLocation)
          filter.optionList = _.chain(filter.optionList).filter(option => option.job_count > 0 || _.includes(selectIds, option.city.id) || _.includes(sameFilterOptionIds, option.city.id)).orderBy(option => [_.includes(['Remote', 'Outside China'], option.city.name), 'city.name'], ['desc', 'desc']).value()
          this.locationFilter = filter
        } else if (filter.option_list) {
          type = 'select'
          filter.optionList = []
          const sameFilterOptionIds = this.formatFilterOptions(hasSelectedFilter, filter, selectFilterOptionIds, isLocation)
          filter.optionList = _.chain(filter.optionList).filter(option => option.job_count > 0 || _.includes(selectIds, option.id) || _.includes(sameFilterOptionIds, option.id)).map(option => addI18nProperty(option, 'label', 'cn_name', 'name')).value()
        }
        const filterInfo = addI18nProperty({
          ...filter,
          multiple: true,
          optionLabel: 'i18nName',
          type
        }, 'title', 'cn_name', 'name')
        return filterInfo
      })
    },
    async loadCompanyJobList (params) {
      const resp = await this.searchCompanyJobList(params)
      if (resp) {
        this.jobList = _.map(resp.data, job => {
          _.forEach(job.job_locations, (item) => {
            if (item.city) {
              addI18nProperty(item.city, 'i18nName', 'cn_name', 'name')
            }
            if (item.region) {
              addI18nProperty(item.region, 'i18nName', 'cn_name', 'name')
            }
            if (item.cbd) {
              addI18nProperty(item.cbd, 'i18nName', 'cn_name', 'name')
            }
          })
          job.roleType = ROLE_TYPE_MAP[job.role_type_value]
          return {
            ...job,
            get i18nName () {
              return isEn() ? job.en_title : job.cn_title
            },
            id: job.pk,
            isHot: job.hot,
            createdTime: job.created_time,
            cityList: job.cities
          }
        })
        this.pagination.total = resp.total_count
        this.allJobIds = resp.job_ids
      }
    },
    loadUrlQuery () {
      const hashStr = decodeURIComponent(this.$route.hash)
      const query = {}
      _.chain(hashStr.substring(1)).split('&').map(item => item.split('=')).forEach((paramArr) => {
        const paramName = paramArr[0]
        let paramVal = null
        if (paramArr.length > 1) {
          paramVal = paramArr[1]
        }
        query[paramName] = paramVal
      }).value()
      return query
    },
    getHashQuery (query) {
      const hashStr = _.chain(query).map((val, key) => {
        if (key === 'open_share') {
          return
        }
        if (val === null || val === undefined) {
          val = ''
          if (key === 'ji' || key === 'jt') {
            val = 0
          }
        }
        return `${key}=${encodeURIComponent(val)}`
      }).filter().join('&').value()
      return hashStr
    },
    setUrlQuery (query) {
      const hashStr = this.getHashQuery(query)
      this.$router.push({ path: this.$route.path, query: this.$route.query, hash: hashStr })
    },
    resetUrl () {
      const query = this.loadUrlQuery()
      query.page = this.pagination.page
      query.page_size = this.pagination.pageSize
      query.keywords = this.keyword
      _.forEach(this.selectedFilterValue, (selectedIds, filterId) => {
        const filter = _.find(this.filterList, { id: parseInt(filterId) })
        let queryName = `${CUSTOM_FILTER_PREFIX}${filterId}`
        const queryVal = _.join(selectedIds, ',')
        if (filter.is_default) {
          if (filter.name === 'Role Type') {
            queryName = 'rt'
          } else if (filter.name === 'Work Time') {
            queryName = 'jwt'
          } else if (filter.name === 'Salary') {
            queryName = 'js'
          } else if (filter.name === 'Location') {
            queryName = 'city'
          }
        }
        query[queryName] = queryVal
      })
      this.setUrlQuery(query)
    },
    async search (isInit) {
      this.loading = true
      try {
        const query = this.loadUrlQuery()
        if (isInit) {
          if (query.page) {
            this.pagination.page = _.parseInt(query.page)
          }
          if (query.page_size) {
            this.pagination.pageSize = _.parseInt(query.page_size)
          }
        }
        const params = {
          page: query.page || this.pagination.page,
          page_size: query.page_size || this.pagination.pageSize,
          company_id: this.company.id,
          keywords: query.keywords,
          type: query.type,
          job_industry_id: query.ji || 0,
          job_type_id: query.jt || 0,
          job_salary_id: query.js,
          job_work_time_id: query.jwt,
          role_type: query.rt,
          // c_lng: query.lng, // PC端没有这个功能
          // c_lat: query.lat, // PC端没有这个功能
          order_by: query.order_by,
          area_city_id: query.city,
          area_region_id: query.region,
          area_id: query.area,
          only_referral: query.refj === '1' ? 1 : null,
          jtitle: query.jtitle,
          // ip_city_name: this.hasSetHashParams ? null : this.search.ipCityName,  // PC端没有这个功能
          jid: query.jid
        }
        _.forEach(query, (val, key) => {
          if (key.startsWith(CUSTOM_FILTER_PREFIX)) {
            params[key] = val
          }
        })
        if (isInit) {
          await this.loadFilterList(params)
          this.initFilterValue(query)
        }
        const cleanedParams = this.cleanParams(params)
        await this.loadCompanyJobList(cleanedParams)
        this.filterList = this.restFilterList(this.filterList)
      } finally {
        this.loading = false
      }
    },
    cleanParams (params) {
      return _.pickBy(params, (value, key) => {
        let defaultFilterName = null
        if (key === 'role_type') {
          defaultFilterName = 'Role Type'
        } else if (key === 'job_work_time_id') {
          defaultFilterName = 'Work Time'
        } else if (key === 'job_salary_id') {
          defaultFilterName = 'Salary'
        } else if (key === 'area_city_id') {
          defaultFilterName = 'Location'
        }
        if (defaultFilterName) {
          return _.find(this.filterList, { name: defaultFilterName, is_default: true })
        }
        if (key.startsWith(CUSTOM_FILTER_PREFIX)) {
          const filterId = parseInt(key.slice(CUSTOM_FILTER_PREFIX.length))
          return _.find(this.filterList, { id: filterId })
        }
        return true
      })
    },
    async initPersonalAgreementStatus () {
      if (!this.hasLogin || !this.isCandidateAccount) {
        return
      }
      const resp = await this.getAgreementStatus({
        company_id: this.company.id
      })
      if (resp) {
        this.personalAgreementStatus = resp
      }
    },
    async initSurveyInfo () {
      if (!this.hasLogin || !this.isCandidateAccount) {
        return
      }
      const resp = await this.getSurveyInfo(this.company.id)
      if (resp) {
        this.surveyInfo = resp
      }
    },
    scrollToJobList () {
      const scrollEl = document.scrollingElement
      if (scrollEl) {
        const headerEl = document.querySelector('.layout-head')
        const bannerEl = document.querySelector('.layout-banner')
        let height = 0
        if (headerEl) {
          height += headerEl.clientHeight
        }
        if (bannerEl) {
          height += bannerEl.clientHeight
        }
        scrollEl.scrollTop = height
      }
    },
    handleSizeChange (pageSize) {
      this.pagination.page = 1
      this.pagination.pageSize = pageSize
      this.isPageChange = true
      this.scrollToJobList()
      this.resetUrl()
    },
    handleCurrentChange (currentPage) {
      this.pagination.page = currentPage
      this.isPageChange = true
      this.scrollToJobList()
      this.resetUrl()
    },
    parseFilterToCondition (filter, filterValue) {
      const hasOptionList = !['keyword'].includes(filter)
      const condition = {
        id: hasOptionList ? filter.id : filter,
        filter,
        filterValue,
        hasOptionList
      }
      if (hasOptionList) {
        let labelKey = 'label'
        if (this.locationFilter && filter.id === this.locationFilter.id) {
          labelKey = 'i18nName'
        }
        Object.defineProperty(condition, 'label', {
          configurable: true,
          enumerable: true,
          get () {
            return filterValue[labelKey]
          }
        })
        Object.defineProperty(condition, 'content', {
          configurable: true,
          enumerable: true,
          get () {
            return `${filter.title}: ${condition.label}`
          }
        })
      } else {
        const contentI18nKey = `company.label.${filter}`
        condition.label = filterValue
        const vm = this
        Object.defineProperty(condition, 'content', {
          configurable: true,
          enumerable: true,
          get () {
            return `${vm.$t(contentI18nKey)}: ${condition.label}`
          }
        })
      }
      return condition
    },
    onFilterChange (filter, filterValue, isRemove, removeAll) {
      this.selectedFilterId = null
      let conditionId = null
      if (filter === 'keyword') {
        conditionId = filter
        this.keyword = filterValue
      } else {
        conditionId = filter.id
        this.selectedFilterId = filter.id
        const selectedIds = this.selectedFilterValue[filter.id]
        if (isRemove && filterValue) {
          selectedIds.splice(selectedIds.indexOf(filterValue.id), 1)
        } else if (removeAll) {
          this.$set(this.selectedFilterValue, filter.id, [])
        } else {
          if (selectedIds) {
            if (filter.multiple) {
              selectedIds.push(filterValue.id)
            } else {
              this.$set(selectedIds, 0, filterValue.id)
            }
          } else {
            this.$set(this.selectedFilterValue, filter.id, [filterValue.id])
          }
        }
      }
      const index = _.findIndex(this.conditionList, condition => condition.id === conditionId && condition.filterValue.id === filterValue.id)
      if (isRemove) {
        this.conditionList.splice(index, 1)
      } else {
        const condition = this.parseFilterToCondition(filter, filterValue)
        if (filter.multiple || index < 0) {
          this.conditionList.push(condition)
        } else {
          this.$set(this.conditionList, index, condition)
        }
      }
      this.pagination.page = 1
      this.resetUrl()
      this.$nextTick(() => {
        this.$refs.filterListRef.resetFilterOptionListHeight()
      })
    },
    onConditionRemoveClick (condition, index) {
      if (condition.hasOptionList) {
        this.selectedFilterId = condition.id
        const selectedIds = this.selectedFilterValue[condition.filter.id]
        selectedIds.splice(selectedIds.indexOf(condition.filterValue.id), 1)
      } else {
        this[condition.filter] = null
      }
      this.conditionList.splice(index, 1)
      this.resetUrl()
      this.$nextTick(() => {
        this.$refs.filterListRef.resetFilterOptionListHeight()
      })
    },
    onClearBtnClick () {
      this.keyword = null
      this.selectedFilterValue = {}
      this.conditionList = []
      this.selectedFilterId = null
      this.$router.push({ query: this.$route.query, hash: '' })
      this.search()
      this.$nextTick(() => {
        this.scrollToJobList()
        this.$refs.filterListRef.resetFilterOptionListHeight()
      })
    },
    isEmployeeOfCompany (job) {
      return job.referral_settings.is_employee
    },
    isHiddenRewards () {
      return Boolean(this.company?.premium?.hidden_rewards)
    },
    isUsePointReplacePayroll (job) {
      return Boolean(this.isEmployeeOfCompany(job) && job.company?.has_use_point_replace_payroll)
    },
    isADPCompany () {
      return Boolean(this.company?.root_company?.id === 7496)
    },
    isCoachCompany () {
      return Boolean(this.company?.root_company?.id === 592)
    },
    handelSurveyClick () {
      if (this.hasLogin && !this.personalAgreementStatus) {
        return
      }
      if (this.surveyInfo.survey?.has_answered) {
        if (this.company.root_company?.id === ROOT_COMPANY_ID.MSD) {
          this.$router.push('/msdchina/join-talent-community')
        } else {
          this.$router.push(`/recruiting/company/${this.company.id}/survey`)
        }
      } else {
        this.showJobAlertDialog = true
      }
    },
    async handleShareJobClick () {
      if (!this.accountIsExits && this.hasReferralPermission) {
        this.showReferralRoleDialog = true
      } else {
        this.handleShowShareDialog()
      }
    },
    handleSubmitIsEmployee () {
      // 员工跳转登录, open_share 登录成功后回调直接打开分享弹窗
      let backUrl = window.location.href
      if (backUrl.includes('#=')) {
        backUrl = `${backUrl}&open_share=1`
      } else {
        backUrl = `${backUrl}#=&open_share=1`
      }

      window.location.href = `/passport/employee/register/?from_job=1&back=${encodeURIComponent(backUrl)}&company_id=${this.company.root_company.id}`
    },
    async handleSubmitNoEmployee () {
      this.handleShowShareDialog()
    },
    async handleShowShareDialog () {
      if (!this.shareToQrCodeUrl) {
        const resp = await this.getReferralShareQrCode({ url: window.location.href })
        if (resp && resp.status === 'success') {
          this.shareToQrCodeUrl = `${resp.qr_code}?_=${(new Date()).getTime()}`
        }
      }
      this.showShareDialog = true
      this.hiddenShareDialog = false
    },
    handleCloseReferralRoleDialog () {
      this.showReferralRoleDialog = false
    },
    handleOpenLocationMap (location, job) {
      this.locationMapDialogInfo.locationList = job.job_locations
      this.locationMapDialogInfo.defaultLocation = location
      this.showJobLocationMap = true
    },
    showPosterDialog () {
      this.hiddenShareDialog = true
    },
    closedPosterDialog () {
      this.showShareDialog = false
    },
    handleShowLearnMore () {
      this.$router.push({ path: '/recruiting/personal/referral/program', query: { company_id: this.company.id } })
    }
  },
  watch: {
    $route: {
      handler () {
        if (!this.$route.hash && this.conditionList.length) {
          this.keyword = null
          this.selectedFilterValue = {}
          this.conditionList = []
          this.selectedFilterId = null
        }
        if (this.isPageChange) {
          this.isPageChange = false
          this.search()
        } else {
          this.debounceSearch()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.company-job-list {
  display: flex;

  .aside-card-container {
    .card-container {
      width: 396px;
      padding: 24px;
      border-radius: 4px;
      background: #ffffff;
      border: 1px solid #e4e7ed;

      + .card-container {
        margin-top: 24px;
      }

      .card-title {
        margin-bottom: 20px;
        font-weight: 500;
      }
    }

    .job-alert {
      .job-alert-btn {
        width: 100%;
        padding: 10px;
        border-color: var(--custom-color);
        border-radius: 2px;
        color: var(--custom-color);
        font-size: 16px;
        line-height: 22px;

        &:hover {
          --rgb-custom-color: rgb(from var(--custom-color) r g b / 5%);
          background-color: var(--rgb-custom-color);
        }
      }
    }

    .follow-us {
      .qr-code-image-wrapper {
        padding: 16px;
        --rgb-custom-color: rgb(from var(--custom-color) r g b / 5%);
        background: var(--rgb-custom-color);

        .qr-code-image {
          display: block;
          width: 180px;
          height: 180px;
          margin: auto;

          &.is-empty {
            background: #fff;
          }
        }
      }
    }
  }

  .job-list-container {
    flex: 1;
    margin-left: 18px;
    padding: 32px;
    border-radius: 6px;
    background: #ffffff;
    border: 1px solid #e4e7ed;
    overflow: hidden;

    .list-head {
      .title-container {
        display: flex;
        margin-bottom: 30px;

        .title {
          margin-right: auto;
          color: #333333;
          font-weight: 500;
        }

        .job-count {
          margin-left: 16px;
          color: #606266;
        }

        .share-btn {
          margin-left: 16px;
          cursor: pointer;

          .share-icon {
            display: block;
            color: #979797;
            font-size: 24px;
            line-height: 1;
            &:hover {
              color: var(--custom-color);
            }
          }
        }
      }

      .condition-container {

        .condition-list {
          display: flex;
          flex-wrap: wrap;
          align-items: center;

          .condition {
            padding: 4px 20px;
            border: 1px solid #dddedf;
            border-radius: 18px;
            margin-bottom: 24px;
            display: flex;
            align-items: center;
            margin-right: 10px;

            .condition-label {
              vertical-align: middle;
            }

            .remove-btn {
              margin-left: 10px;
              vertical-align: middle;
              cursor: pointer;
            }
          }

          .clear-btn {
            margin-left: 10px;
            color: var(--custom-color);
            cursor: pointer;
            margin-bottom: 24px;
          }
        }
      }
    }

    .job-list {
      border-top: 1px solid #dcdfe6;

      .pagination {
        margin-top: 32px;
        text-align: right;
        ::v-deep {
          .el-pager {
            .active {
              background-color: var(--custom-color);
              color: #fff !important;
            }
            .number {
              &:hover {
                color: var(--custom-color);
              }
            }
          }
        }
      }

      p {
        line-height: 22px;
        font-size: 14px;
        padding: 10px 0;
        color: #666;
        margin: 0 auto;
        width: 400px;
        text-align: center;
      }
    }
  }

  .share-dialog {

    &.hidden-dialog {
      display: none;
    }

    .title {
      margin-bottom: 28px;
    }

    .share-title {
      color: #606266;
      margin-bottom: 30px;
    }

    .job-poster-title {
      color: #606266;
      margin-bottom: 24px;
    }

    .share-job-content {
      padding: 0 78px;
      ::v-deep {
        .share-line {
          .share {
            .iconfont {
              font-size: 54px;
            }
          }
        }
      }
    }

    .job-poster-info {
      ::v-deep {
        .job-poster {
          margin: 0 78px;
        }
      }
    }

    .learn-more {
      margin-top: 16px;
      text-align: right;
      margin-bottom: 16px;
      a {
        color: var(--custom-color);
        cursor: pointer;
      }
    }

    .el-divider {
      .el-divider__text {
        color: #909399;
      }
    }
  }
}
</style>

<style lang="scss">
.share-content-referral-role-dialog-job-list {
  .referral-role-content {
    min-height: 80px;
    font-size: 14px;
    font-weight: 400;
    color: #303313;
  }
  .el-dialog__footer {
    .dialog-footer {
      .cancel-btn {
        background-color: var(--custom-color);
        color: #fff;
        border: 1px solid var(--custom-color);
      }
      .save-btn {
        background-color: var(--custom-color);
        color: #fff;
        border: 1px solid var(--custom-color);

        &:hover {
          background: var(--custom-color);
          border-color: var(--custom-color);
        }
      }
    }
  }
}
</style>
